import type { SupabaseClient } from '@supabase/supabase-js'
import type { SignOut } from '@/modules/auth/use-cases'

export class SupabaseSignOutRepository {
  constructor(private readonly client: SupabaseClient) {}

  execute: SignOut = async () => {
    const { error } = await this.client.auth.signOut()
    if (error) throw error
  }
}
